
import React, { useEffect, useState, forwardRef, useRef } from "react";

import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import {
    Box, Button, Grid, List, ListItem, ListItemAvatar, ListItemText, Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import HomeIcon from '@mui/icons-material/Home';
import styles from '../../../styles.module.css';
import SalesRegister from "../saleRegister/SalesRegister";
import PurchaseRegister from "../purchaseRegister/PurchaseRegister";
import SalesOrderHistory from "../saleOrderHistory/SalesOrderHistory";
import PurchaseOrderHistory from "../purchaseOrderHistory/PurchaseOrderHistory";
import AccountStatement from "../accountStatement/AccountStatement";
import Outstanding from "../outstanding/Outstanding";
import PaymentRegister from "../paymentRegister/PaymentRegister";
import ReportsDashboard from "./ReportsDashboard";
import { Link, NavLink } from "react-router-dom";
import Breadcrumb from "../../reusableComponent/Breadcrumb";

const CustomTab = styled(Tab)(({ theme }) => ({
    minWidth: '9px',
    minHeight: '8px',
    marginRight: '2px',
    fontWeight: '400',
    fontSize: '13px',
    color: '#000000',
    padding: '4px 4px 4px 4px',
    letterSpacing: '0.3px',
    wordSpacing: '0.8px',
    textTransform: 'none',
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 2 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


function ReportsHome() {
    const [selectedTab, setSelectedTab] = useState(0);
    const [previousTabs, setPreviousTabs] = useState([]);

    const handleChangeTab = (event, newValue) => {
        setPreviousTabs((prev) => [...prev, selectedTab]); // Store the previous active tab
        setSelectedTab(newValue);
    };

    const handlePreviousTab = () => {
        if (previousTabs.length > 0) {
            const previousTab = previousTabs.pop();
            setSelectedTab(previousTab);
            setPreviousTabs([...previousTabs]); // Remove the last tab from the previousTabs array
        }
    };

    return (
        <>
            <Breadcrumb
                routeSegments={[
                    { name: 'Reports', },
                ]}
            />
            <Paper className={`${styles.list_container}`}>
                <Grid container style={{ height: '420px', }}>
                    <Grid item xs={3} >
                        <List sx={{ width: '100%', display: 'inline-block' }}>
                            <>
                                <NavLink to="/reports/sales_register" className={`${styles.underline}`}>
                                    <ListItem className={`${styles.home_menu}`}>
                                        <ListItemAvatar>
                                            <Typography className={`${styles.menu_i}`}> SR</Typography>
                                        </ListItemAvatar>
                                        <ListItemText primary="SALES REGISTER " primaryTypographyProps={{ fontSize: '15px' }} />
                                    </ListItem>
                                </NavLink>
                                <NavLink to="/reports/purchase-register" className={`${styles.underline}`}>
                                    <ListItem className={`${styles.home_menu}`}>
                                        <ListItemAvatar>
                                            <Typography className={`${styles.menu_i}`}> PR </Typography>
                                        </ListItemAvatar>
                                        <ListItemText primary="PURCHASE REGISTER" primaryTypographyProps={{ fontSize: '15px' }} />
                                    </ListItem>
                                </NavLink>
                                <NavLink to="/reports/account-statement" className={`${styles.underline}`}>
                                    <ListItem className={`${styles.home_menu}`}>
                                        <ListItemAvatar>
                                            <Typography className={`${styles.menu_i}`}> AS </Typography>
                                        </ListItemAvatar>
                                        <ListItemText primary="ACCOUNT STATEMENT" primaryTypographyProps={{ fontSize: '15px' }} />
                                    </ListItem>
                                </NavLink>
                                <NavLink to="/reports/payment-register" className={`${styles.underline}`}>
                                    <ListItem className={`${styles.home_menu}`}>
                                        <ListItemAvatar>
                                            <Typography className={`${styles.menu_i}`}>PR</Typography>
                                        </ListItemAvatar>
                                        <ListItemText primary="PAYMENT REGISTER" primaryTypographyProps={{ fontSize: '15px' }} />
                                    </ListItem>
                                </NavLink>
                                <NavLink to="/reports/so-history" className={`${styles.underline}`}>
                                    <ListItem className={`${styles.home_menu}`}>
                                        <ListItemAvatar>
                                            <Typography className={`${styles.menu_i}`}>SH</Typography>
                                        </ListItemAvatar>
                                        <ListItemText primary="SALES ORDER HISTORY" primaryTypographyProps={{ fontSize: '15px' }} />
                                    </ListItem>
                                </NavLink>
                                <NavLink to="/reports/po-history" className={`${styles.underline}`}>
                                    <ListItem className={`${styles.home_menu}`}>
                                        <ListItemAvatar>
                                            <Typography className={`${styles.menu_i}`}>PH</Typography>
                                        </ListItemAvatar>
                                        <ListItemText primary="PURCHASE ORDER HISTORY" primaryTypographyProps={{ fontSize: '15px' }} />
                                    </ListItem>
                                </NavLink>
                                <NavLink to="/reports/outstanding" className={`${styles.underline}`}>
                                    <ListItem className={`${styles.home_menu}`}>
                                        <ListItemAvatar>
                                            <Typography className={`${styles.menu_i}`}>OR</Typography>
                                        </ListItemAvatar>
                                        <ListItemText primary="OUTSTANDING REPORT" primaryTypographyProps={{ fontSize: '15px', }} />
                                    </ListItem>
                                </NavLink>
                            </>
                        </List>
                    </Grid>
                </Grid>
            </Paper>
            {/* <Paper className={`${styles.list_container}`}>
                <Box sx={{ width: '100%', padding: '4px', paddingTop: '4px' }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider', maxHeight: '32px', paddingLeft: '12px' }}>
                        <Tabs value={selectedTab} onChange={handleChangeTab} aria-label="basic tabs example"
                            indicatorColor="none"
                            textColor="#000000"
                            TabIndicatorProps={{
                                sx: { backgroundColor: "#ff6600", marginBottom: '17px' }
                            }}
                            variant="scrollable">
                            <CustomTab label={<HomeIcon />} {...a11yProps(0)} />
                            <CustomTab label="Sales Register" {...a11yProps(1)} />
                            <CustomTab label="Purchase Register" {...a11yProps(2)} />
                            <CustomTab label="Account Statement" {...a11yProps(3)} />
                            <CustomTab label="Payment Register" {...a11yProps(4)} />
                            <CustomTab label="Sales Order History" {...a11yProps(5)} />
                            <CustomTab label="Puchase Order History" {...a11yProps(6)} />
                            <CustomTab label="Outstanding" {...a11yProps(7)} />
                            <CustomTab label="GST Register" {...a11yProps(8)} />
                            <CustomTab label="Report" {...a11yProps(9)} />
                        </Tabs>
                    </Box>
                    <TabPanel value={selectedTab} index={0}>
                        <ReportsDashboard/>
                      
                    </TabPanel>
                    <TabPanel value={selectedTab} index={1}>
                        <SalesRegister handlePreviousBtn={handlePreviousTab} previousBtn={previousTabs} />
                    </TabPanel>
                    <TabPanel value={selectedTab} index={2} >
                        <PurchaseRegister handlePreviousBtn={handlePreviousTab} previousBtn={previousTabs} />
                    </TabPanel>
                    <TabPanel value={selectedTab} index={3}>
                        <AccountStatement handlePreviousBtn={handlePreviousTab} previousBtn={previousTabs} />
                    </TabPanel>
                    <TabPanel value={selectedTab} index={4}>
                        <PaymentRegister handlePreviousBtn={handlePreviousTab} previousBtn={previousTabs} />
                    </TabPanel>
                    <TabPanel value={selectedTab} index={5}>
                        <SalesOrderHistory handlePreviousBtn={handlePreviousTab} previousBtn={previousTabs} />
                    </TabPanel>
                    <TabPanel value={selectedTab} index={6}>
                        <PurchaseOrderHistory handlePreviousBtn={handlePreviousTab} previousBtn={previousTabs} />
                    </TabPanel>
                    <TabPanel value={selectedTab} index={7}>
                        <Outstanding handlePreviousBtn={handlePreviousTab} previousBtn={previousTabs} />
                    </TabPanel>
                    <TabPanel value={selectedTab} index={8}>
                        demo
                    </TabPanel>
                    <TabPanel value={selectedTab} index={9}>
                        demo
                    </TabPanel>
                </Box>
            </Paper> */}
        </>
    )
}

export default ReportsHome;